import { render, staticRenderFns } from "./ProductCottonPage.vue?vue&type=template&id=8907fa7a&scoped=true&"
import script from "./ProductCottonPage.vue?vue&type=script&lang=js&"
export * from "./ProductCottonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8907fa7a",
  null
  
)

export default component.exports